<template>
    <CutRequestList></CutRequestList>
</template>

<script>
import { defineAsyncComponent } from "vue";

const AuthLayout = defineAsyncComponent(() =>
    import("../../Layouts/AuthLayout.vue")
);
const CutRequestList = defineAsyncComponent(() =>
    import("../../components/CNC/CutRequestList/CutRequestList.vue")
);

export default {
    name: "Cut_Request_List", //The name you are in should not equal the name of the component you are importing.
    components: { CutRequestList, AuthLayout },
};
</script>

<style scoped></style>
